import { Box, HStack } from "@kazaar-platform/design-system";
import Skeleton from "react-loading-skeleton";

export const OrderItemDetailsTabsSkeleton = () => {
  return (
    <HStack gap="sp-md">
      {Array(3).map((i) => (
        <Box key={i} flex>
          <Skeleton height={40} width="100%" />
        </Box>
      ))}
    </HStack>
  );
};
